exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-body.padding-bottom[data-v-6cd228e9]{padding-bottom:220px}", ""]);

// exports
